import type { LandingPlanDTO } from '../types/landing.types';
import type { Plan } from '../../../system/types/system.types';

const delay = (ms: number) => new Promise(res => setTimeout(res, ms));

export const fetchLandingPlans = async (): Promise<LandingPlanDTO[]> => {
	await delay(400);
	return [];
};

export const fetchListablePlans = async (): Promise<Plan[]> => {
	await delay(300);
	return [];
};

export const addLandingPlan = async (planId: string): Promise<LandingPlanDTO> => {
	await delay(400);
	return {
		_id: String(Date.now()),
		plan: { _id: planId } as Plan,
	};
};

export const removeLandingPlan = async (landingPlanId: string): Promise<void> => {
	await delay(300);
	void landingPlanId;
};
